import { render, staticRenderFns } from "./PaperlessType.vue?vue&type=template&id=fe0e1ce4"
import script from "./PaperlessType.vue?vue&type=script&lang=js"
export * from "./PaperlessType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports